module.exports = __webpack_public_path__ + "static/meal-planner-f2ebea29c2fe459776b0f893d2fcc996.jpg";